export var sortByTitle = function (array) {
    return array.sort(function (a, b) { return (a.title > b.title ? 1 : -1); });
};
//# sourceMappingURL=sortByName.js.map